export function sizeOf(keyboard: KeyboardState): number {
  return keyboard.length;
}
